import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchService } from 'src/app/services/search.service';

@Component({
  selector: 'app-search-results-layout',
  templateUrl: './search-results-layout.component.html',
  styleUrls: ['./search-results-layout.component.scss'],
})
export class SearchResultsLayoutComponent implements OnInit {
  route = inject(ActivatedRoute);
  searchService = inject(SearchService);
  router = inject(Router);
  data: any[] = []

  searchTerm: string = '';
  isFilterVisible = false;
  searchTermArchive: string = '';
  searchResults = this.searchService.filteredResults();
  typeFilters = this.searchService.typeFilters();
  tagFilters = this.searchService.tagFilters();
  searchPerformed: boolean = false;
  isLoading = this.searchService.loading
  isArchiveSearch: boolean = false

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.searchTerm = params['q'];
      this.searchTermArchive = params['archive'];
  
      if (this.searchTermArchive && !this.searchResults.length) {
        this.searchService.search(this.searchTermArchive, true);
      }
  
      if (this.searchTerm && !this.searchResults.length) {
        this.searchService.search(this.searchTerm);
      }
  
      if (!this.searchTerm) {
        this.searchService.clearSearch();
      }
    });
  }
  

  search(newTerm: boolean = false) {
    if (newTerm) this.searchService.clearSearch();

    this.router.navigate([], {
      queryParams: { q: this.searchTerm },
    });
    this.searchService.search(this.searchTerm);
  }

  triggerSearch() {
    if (this.searchTerm.trim().length >= 3) {
      this.searchService.clearSearch(); 
      this.searchService.search(this.searchTerm);
      this.searchService._loading.set(true)

    }
  }

  loadMoreResults() {
    this.searchService.search(this.searchTerm); // Trigger paginated search
  }

  // Archive search logic
  searchArchived() {
    this.isArchiveSearch = !this.isArchiveSearch
    this.searchService.clearSearch();
    this.searchService.search(this.searchTerm, this.isArchiveSearch);
  }

  // Toggle filter visibility
  toggleFilter() {
    this.isFilterVisible = !this.isFilterVisible;
  }

  onInputChange() {
    this.searchPerformed = false;
  }

  
}
